module.exports = __webpack_public_path__ + "static/media/8900_Front.3c9f24cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Front.jpg
// module id = 576
// module chunks = 0